
import React from 'react';
import { MonthlyResult, PricingTier } from './types';

export const PERFORMANCE_DATA: MonthlyResult[] = [
  { year: 2025, months: { Ene: 3.97, Feb: 3.51, Mar: 5.21, Abr: 8.99, May: 5.17, Jun: 3.77, Jul: 5.07, Ago: 2.20, Sep: 4.92, Oct: 3.97, Nov: 2.14, Dic: 3.05 }, total: 51.97 },
  { year: 2024, months: { Ene: 4.13, Feb: 2.61, Mar: 2.08, Abr: 3.65, May: 2.06, Jun: 2.40, Jul: 2.63, Ago: 3.93, Sep: 3.62, Oct: 4.07, Nov: 4.55, Dic: 3.65 }, total: 39.39 },
  { year: 2023, months: { Ene: 6.36, Feb: 5.15, Mar: 4.70, Abr: 4.51, May: 3.67, Jun: 4.91, Jul: 6.23, Ago: 4.41, Sep: 3.01, Oct: 4.99, Nov: 4.25, Dic: 4.25 }, total: 56.43 },
  { year: 2022, months: { Ene: 6.89, Feb: 4.51, Mar: 7.69, Abr: 5.62, May: 5.64, Jun: 6.53, Jul: 5.67, Ago: 4.77, Sep: 5.93, Oct: 6.78, Nov: 9.66, Dic: 6.56 }, total: 76.25 },
  { year: 2021, months: { Ene: 3.59, Feb: 3.25, Mar: 9.99, Abr: 6.49, May: 10.22, Jun: 3.01, Jul: 3.80, Ago: 2.71, Sep: 3.91, Oct: 2.93, Nov: 4.54, Dic: 4.02 }, total: 58.45 },
  { year: 2020, months: { Ene: 6.26, Feb: 7.06, Mar: 17.54, Abr: 7.25, May: 4.48, Jun: 6.82, Jul: 6.49, Ago: 7.23, Sep: 6.59, Oct: 4.17, Nov: 4.81, Dic: 5.10 }, total: 83.79 },
  { year: 2019, months: { Ene: 3.56, Feb: 3.27, Mar: 2.82, Abr: 2.36, May: 2.93, Jun: 2.01, Jul: 3.45, Ago: 3.45, Sep: 3.30, Oct: 2.92, Nov: 2.44, Dic: 2.89 }, total: 35.39 },
  { year: 2018, months: { Ene: 6.19, Feb: 4.01, Mar: 6.15, Abr: 3.47, May: 5.68, Jun: 4.92, Jul: 3.65, Ago: 5.84, Sep: 3.94, Oct: 6.50, Nov: 3.89, Dic: 4.67 }, total: 58.90 },
  { year: 2017, months: { Ene: 8.06, Feb: 3.76, Mar: 4.98, Abr: 4.63, May: 6.22, Jun: 3.67, Jul: 5.23, Ago: 4.90, Sep: 4.13, Oct: 3.83, Nov: 3.20, Dic: 3.59 }, total: 56.19 },
  { year: 2016, months: { Ene: 7.81, Feb: 10.07, Mar: 6.32, Abr: 5.73, May: 5.79, Jun: 6.56, Jul: 6.79, Ago: 3.73, Sep: 3.84, Oct: 3.83, Nov: 6.92, Dic: 4.63 }, total: 72.93 },
  { year: 2015, months: { Ene: 9.27, Feb: 5.95, Mar: 7.17, Abr: 6.59, May: 8.91, Jun: 7.64, Jul: 9.45, Ago: 10.12, Sep: 8.44, Oct: 8.68, Nov: 4.19, Dic: 7.30 }, total: 83.69 },
  { year: 2014, months: { Ene: 7.56, Feb: 4.51, Mar: 4.55, Abr: 3.05, May: 2.88, Jun: 2.01, Jul: 2.49, Ago: 1.78, Sep: 4.13, Oct: 7.45, Nov: 5.22, Dic: 6.19 }, total: 51.82 },
  { year: 2013, months: { Ene: 3.61, Feb: 6.91, Mar: 3.92, Abr: 4.57, May: 7.80, Jun: 7.29, Jul: 4.99, Ago: 6.57, Sep: 4.22, Oct: 7.04, Nov: 3.55, Dic: 5.16 }, total: 65.62 },
  { year: 2012, months: { Ene: 5.47, Feb: 5.69, Mar: 5.92, Abr: 4.31, May: 5.10, Jun: 4.32, Jul: 5.21, Ago: 4.06, Sep: 5.98, Oct: 8.80, Nov: 3.38, Dic: 4.88 }, total: 63.10 },
  { year: 2011, months: { Ene: 10.22, Feb: 10.96, Mar: 7.09, Abr: 5.60, May: 7.24, Jun: 2.98, Jul: 3.76, Ago: 8.99, Sep: 9.04, Oct: 9.62, Nov: 8.73, Dic: 6.78 }, total: 100.94 },
  { year: 2010, months: { Ene: 7.39, Feb: 6.75, Mar: 8.75, Abr: 6.88, May: 13.50, Jun: 8.44, Jul: 8.39, Ago: 8.21, Sep: 7.11, Oct: 7.64, Nov: 9.65, Dic: 7.03 }, total: 99.72 }
];

export const PRICING_TIERS: PricingTier[] = [
  {
    id: 'starter',
    paymentLink: 'https://buy.stripe.com/bJeeVd1fx1fg3z4aS08g002',
    name: 'LICENCIA STARTER',
    price: '450',
    period: 'anual',
    features: [
      'Licencia anual AxiomityFX',
      'Capital mínimo necesario: 5.000€',
      'Operar en el bróker patrocinado (Roboforex)',
      'Permitidos 1 instancia del par EURUSD y 2 instancias del AUDCAD',
      'Soporte técnico en la instalación',
      'Soporte general vía Telegram',
      'Actualizaciones gratuitas'
    ]
  },
  {
    id: 'pro',
    paymentLink: 'https://buy.stripe.com/9B614ngarf66b1wgck8g001',
    name: 'LICENCIA PRO',
    price: '800',
    period: 'anual',
    features: [
      'Licencia anual AxiomityFX',
      'Capital mínimo necesario: 10.000€',
      'Operar en el bróker patrocinado (Roboforex)',
      'Permitidos 2 instancias del par EURUSD y 4 instancias del AUDCAD',
      'Soporte técnico en la instalación',
      'Soporte general vía Telegram',
      'Actualizaciones gratuitas'
    ],
    recommended: true
  },
  {
    id: 'unlimited',
    paymentLink: 'https://buy.stripe.com/00wcN58HZbTU5HcbW48g000',
    name: 'LICENCIA UNLIMITED',
    price: '2.000',
    period: 'anual',
    features: [
      'Licencia anual AxiomityFX',
      'Capital mínimo necesario: 10.000€',
      'Operar en cualquier bróker',
      'Permitidos 2 instancias del par EURUSD y 4 instancias del AUDCAD',
      'Soporte técnico en la instalación',
      'Soporte general vía Telegram',
      'Actualizaciones gratuitas'
    ]
  }
];

export const MONTH_NAMES = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
